/*
*###############################################################################
*Module Name                   : CreditNote.js                                    #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          :  Friday, june 10th 2022, 1:16:56 pm               #
*Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/
import React, { useState, useEffect, useContext } from "react"
import { MetaTags } from "react-meta-tags"
import { Card, Col, Container, Row, CardBody, Alert, TabContent, TabPane } from "reactstrap"

//**Importing required componant files   */
import Breadcrumb from "components/Common/Breadcrumb"
import DPTopToolBar from "framework/widgets/DPTopToolBar"
import CreditNoteContent from "./CreditNoteContent"
import DPInfoBox from "framework/layout/DPInfoBox"
import DPPermission from "framework/widgets/DPPermission"

import { Text, Numeric } from "framework/validators/TextValidation"
import DPAlert from "framework/widgets/DPAlert"
import {
  getBalanceOrderSheet, getQuotationDetails,
  setInvoiceCancel, getPendingOrderSheetDetails,
  getPayTXNSetup, LoadPAYTXNDetails, savePayTransaction, GetPayTransaction, GetHeaderReasonTypesCashBook
} from "./CreditNoteController"
//*Detail content */
import CreditNoteDetails from "./CreditNoteDetails"
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
//**End Importing required componant files */

import { Context } from '../../../src/app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import DPNavBar from "framework/widgets/DPNavBar"
import { CreditNoteDocumets } from "./CreditNoteDocumets"
import { getApprovalStatusAndMessage, GetRules, RemarkValidation, SendFCM } from "pages/Transactions/Transaction/TransactionController"
import { PaymentRuleValidation } from "./CreditNoteRuleValidation"
import { CreditNoteApprovals } from "./CreditNoteApprovals"
import DPPrintOption from "framework/widgets/DPPrintOptions"


const DetailObj = [{
  "type": "",
  "document": "",
  "date": "",
  "reference": "",
  "location": "",
  "locationName": "",
  "netAmount": 0,
  "paidAmount": 0,
  "dueAmount": 0,
  "creditAmount": 0,
  "payment": 0,
  "id": 1,
}]


const paymentObj = [{
  paycode: "",
  paydesc: "",
  payDetcode: "",
  payDetName: "",
  payAmount: 0,
  accountCode: "",
  expDate: "",
  overpayEnable: false,
  paymodeEnable: false,
  overpayValue: 0,
  isPaymodeDetail: false,
  printCheque: false,
  acPayee: "",
  dateDisable: true,
  payDetDisable: true,
  refType: "",
  refCheck: 0,
  id: 1
}]


const CreditNote = props => {

  var time = process.env.REACT_APP_ALERTTIMEOUT

  let history = useHistory();

  const {
    getMenuDetails, txnDecimalAmt, masterAuditLog, addtoFavourite
  } = useContext(Context);


  //*** User input related states */
  var currentDate = new Date();
  Date.prototype.addDays = function (days) {
    this.setDate(this.getDate() + parseInt(days));
    return this;
  };

  // to add 4 days to current date
  // currentDate.addDays(14);


  // let searchPara = props.location.search.replace("?", "").toUpperCase() //'GRN'
  // const type = props.location.search.replace("?", "").toUpperCase().substring(0, searchPara.includes("&") ? searchPara.indexOf("&") : searchPara.length)
  const authToken = localStorage.getItem("authToken")



  let searchPara = props.location.search.replace("?", "").toUpperCase(); // 'GRN&1000100000053&0001'

  const params = searchPara.split('&'); // ['GRN', '1000100000053', '0001']

  const type = params.length > 0 ? params[0] : ""; // Extracts 'GRN'
  const docNo = params.length > 1 ? params[1] : ""; // Extracts '1000100000053'
  const urlLocation = params.length > 2 ? params[2] : ""; // Extracts '0001'




  const [strCode, SetCode] = useState("") // Set Code
  const [blCodeEnable, SetCodeEnable] = useState(false)
  const [strDate, SetDate] = useState(new Date(currentDate).toISOString().split("T")[0]) //Set DATE
  const [blDateEnable, SetDateEnable] = useState(false)
  const [strCustomer, SetCustomer] = useState("")
  const [strCustomerName, SetCustomerName] = useState("")
  const [strSupplier, SetSupplier] = useState("")
  const [strSupplierName, SetSupplierName] = useState("")
  const [strSalesExec, SetSalesExec] = useState("")
  const [strSalesExecName, SetSalesExecName] = useState("")
  const [strLocation, SetLocation] = useState("")
  const [strLocationName, SetLocationName] = useState("")
  const [strMode, SetMode] = useState("")
  const [strModeName, SetModeName] = useState("")
  const [blCustomerEnable, SetCustomerEnable] = useState(false)
  const [strRemarks1, SetRemarks1] = useState("")
  const [strRemarks2, SetRemarks2] = useState("")
  const [blRemarks1Enable, SetRemarks1Enable] = useState(false)
  const [strPayRemarks1, SetPayRemarks1] = useState("")
  const [blPayRemarks1Enable, SetPayRemarks1Enable] = useState(false)
  const [addNew, SetAddNew] = useState(true)
  const [strMobileNo, SetMobileNo] = useState("")
  const [blMobileNoEnable, SetMobileNoEnable] = useState(false)
  const [strAddress1, SetAddress1] = useState("")
  const [strAddress2, SetAddress2] = useState("")
  const [strAddress3, SetAddress3] = useState("")
  const [strEmail, SetEmail] = useState("")
  const [strOrderNo, SetrOrderNo] = useState("")
  const [strDeliveryline1, SetDeliveryline1] = useState("")
  const [blDeliveryline1Enable, SetDeliveryline1Enable] = useState(false)
  const [strDeliveryline2, SetDeliveryline2] = useState("")
  const [blDeliveryline2Enable, SetDeliveryline2Enable] = useState(false)
  const [strDeliveryline3, SetDeliveryline3] = useState("")
  const [blDeliveryline3Enable, SetDeliveryline3Enable] = useState(false)
  const [strOrderStatus, SetOrderStatus] = useState("")
  const [blOrderStatusEnable, SetOrderStatusEnable] = useState(false)
  const [blOrderNoEnable, SetOrderNoEnable] = useState(false)
  const [IsActive, SetActive] = useState(true)//Set Active state
  const [blActiveEnable, SetActiveEnable] = useState(false)
  //*** End User input related states */
  //*** User input related Details level */
  const [dbSellingAmount, SetdbSellingAmount] = useState("0.0")
  const [dbGrossAmount, SetdbGrossAmount] = useState("0.0")
  const [dbDiscountPer, SetdbDiscountPer] = useState("0.0")
  const [dbNetAmount, SetdbNetAmount] = useState("0.0")
  const [TotalBookQty, setTotalBookQty] = useState("0.0")
  const [TotalCostValue, setTotalCostValue] = useState("0.0")
  const [TotalSellingValue, setTotalSellingValue] = useState("0.0")
  const [TotalPayValue, setTotalPayValue] = useState("0.0")
  //*** User input related Details level */
  //*** User Activity related states*/

  const [AlertMsg, setAlertMsg] = useState("")
  const [AlertColor, setAlertColor] = useState("")
  const [AlertShow, setAlertShow] = useState(false)
  const [ShowTaxTable, setShowTaxTable] = useState(false)
  const [blDiasableGrid, SetblDiasableGrid] = useState(false)

  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [modal_xlarge1, setmodal_xlarge1] = useState(false)
  const [model_xlarge_supplier, setmodel_xlarge_supplier] = useState(false)
  const [model_xlarge_customer, setmodel_xlarge_customer] = useState(false)
  const [model_xlarge_saleExec, setmodel_xlarge_saleExec] = useState(false)
  const [model_xlarge_location, setmodel_xlarge_location] = useState(false)
  const [model_xlarge_mode, setmodel_xlarge_mode] = useState(false)

  const [saveEnable, setSaveEnable] = useState(true)
  const [editEnable, setEditEnable] = useState(false)
  const [PrintEnable, setPrintEnable] = useState(false)
  const [CancelEnable, setCancelEnable] = useState(false)
  const [crEnable, setCrEnable] = useState(false)
  const [crBy, setCrBy] = useState("")
  const [mdBy, setMdBy] = useState("")
  const [crDate, setCrDate] = useState("")
  const [mdDate, setMdDate] = useState("")
  const [menuCode, SetMenuCode] = useState("")
  const [deleteEnable, SetDeleteEnable] = useState(false)
  const [menu, SetMenu] = useState("")
  //*** End User activity related staes */

  //*** useState to save table data */
  const [DataTables, SetDatatable] = useState([])
  const [DataTables1, SetDatatable1] = useState([])
  const [LocationCode, setLocationCode] = useState("")
  const [loadingAlert, SetLoadingAlert] = useState(false)
  const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
  //*** End of useStates */

  //User Permission related usestates
  const [permissionAlertShow, setPermissionAlertShow] = useState(false)
  const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
  const [permissionReasonShow, setPermissionReasonShow] = useState(false)
  const [permissionName, setPermissionName] = useState("")
  const [permissionPassword, setPermissionPassword] = useState("")
  const [permissionNameDisable, setPermissionNameDisable] = useState(false)

  const [disabled, setDisabled] = useState(false)
  const [disableTransBTN, setDisableTransBTN] = useState(false)
  const [detailTable, setDetailTable] = useState(DetailObj)
  const [rowsPay, setRowsPay] = useState(paymentObj)
  const [Reason, setReason] = useState("Created")


  const [modal_xlargeSup, setmodal_xlargeSup] = useState(false)
  const [LogUserType, setLogUserType] = useState("")
  //*****Menu Rights Start*/
  const [menuAccess, SetMenuAccess] = useState(false)
  const [menuCreate, SetMenuCreate] = useState(false)
  const [menuDelete, SetMenuDelete] = useState(false)
  const [menuModify, SetMenuModify] = useState(false)
  const [menuPrint, SetMenuPrint] = useState(false)
  const [menuProcess, SetMenuProcess] = useState(false)
  const [menuName, SetMenuName] = useState("")
  const [parentName, SetParentName] = useState("")
  const [LogCompanyCode, setLogCompanyCode] = useState("")

  //*****Menu Rights End */


  //*** displayField related states */
  const [dispCustomer, setDispCustomer] = useState(false)
  const [dispSupplier, setDispSupplier] = useState(false)
  const [dispSalesExec, setDispSalesExec] = useState(false)
  const [dispMode, setDispMode] = useState(false)
  const [overPay, setOverPay] = useState(false)
  const [advancePayment, setAdvancePayment] = useState(false)

  const [PY_SUP_DISPLAY, setPY_SUP_DISPLAY] = useState('')
  const [PY_SUP_SEARCH, setPY_SUP_SEARCH] = useState('')
  const [PY_CUS_DISPLAY, setPY_CUS_DISPLAY] = useState('')
  const [PY_CUS_SEARCH, setPY_CUS_SEARCH] = useState('')
  const [PY_SA_DISPLAY, setPY_SA_DISPLAY] = useState('')
  const [PY_SA_SEARCH, setPY_SA_SEARCH] = useState('')
  //*** End of displayField related states */


  const [TotalNetAmount, setTotalNetAmount] = useState(parseFloat(0).toFixed(txnDecimalAmt))
  const [TotalPaidAmount, setTotalPaidAmount] = useState(parseFloat(0).toFixed(txnDecimalAmt))
  const [TotalDueAmount, setTotalDueAmount] = useState(parseFloat(0).toFixed(txnDecimalAmt))
  const [TotalPaymentAmout, setTotalPaymentAmout] = useState(parseFloat(0).toFixed(txnDecimalAmt))


  const [Gen_Vendor_Disabled, setGen_Vendor_Disabled] = useState(false)
  const [Gen_Customer_Disabled, setGen_Customer_Disabled] = useState(false)
  const [Gen_SalesExec_Disabled, setGen_SalesExec_Disabled] = useState(false)
  const [Gen_Location_Disabled, setGen_Location_Disabled] = useState(false)
  const [Gen_Mode_Disabled, setGen_Mode_Disabled] = useState(false)


  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
  const [processStatus, setProcessStatus] = useState(0)
  const [isDocProcessed, setIsDocProcessed] = useState("")
  const [ProcessDisable, setProcessDisable] = useState(false)
  const [ReasonTypes, setReasonTypes] = useState([])
  const [helpUrl, setHelpUrl] = useState("")

  const [customActiveTab, setcustomActiveTab] = useState("1")

  const [selectedAttachFiles, setSelectedAttachFiles] = useState([])
  const [attachFileNames, setAttachFileNames] = useState([]);
  const [clearAttachmentEdit, setClearAttachmentEdit] = useState(false)
  const [handleClearStatus, setHandleClearStatus] = useState(false)

  const [approvalRequests, setApprovalRequests] = useState([])

  const [payTxnSetup, setPayTxnSetup] = useState({})

  const [printoptionShow, setprintoptionShow] = useState(false)


  const [tabList, setTabList] = useState([
    {
      text: "General",
      icon: "fas fa-home",
      tabID: "1",
      onClick: () => {
        toggleCustom("1")
      },
    },
    {
      text: "Document",
      icon: "far fa-user",
      tabID: "2",
      onClick: () => {
        toggleCustom("2")
      },
    }
  ])


  useEffect(async () => {
    const ApiURL = window.Links.ApiURL

    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]
    var CompanyCode = obj[5]

    var menuDetail = await getMenuDetails(window.location.pathname + "?" + type)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
    var parentname = menuDetail?.parentName

    SetMenu(menu)
    SetParentName(parentname)
    setLocationCode(LocationCode)
    setLogCompanyCode(CompanyCode)
    setLogUserType(LogUserType)

    var requestOptions = {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      redirect: "follow",
    };

    fetch(`${ApiURL}login/menu/${LogUserType}/${menu}`, requestOptions)
      .then(response => response.json())
      .then(result => {
        SetMenuAccess(result.data.strMenuAccessRight)
        SetMenuCreate(result.data.strMenuCreateRight)
        SetMenuDelete(result.data.strMenuDeleteRight)
        SetMenuModify(result.data.strMenuModifyRight)
        SetMenuPrint(result.data.strMenuPrintRight)
        SetMenuProcess(result.data.strMenuProcessRight)
        SetMenuName(result.data.strMenuName)
        SetMenuCode(result.data.strMenuTag)
        setHelpUrl(result.data.strHelpUrl)
        setPermissionReasonShow(result.data.strMenuReasonShow)
      }).catch(error =>
        console.log('error', error)
      );

    ClearItem()//When type change reset all fields


  }, [type])


  useEffect(async () => {

    if (docNo != "") {
      GetDocumentData(docNo)
    }

  }, [docNo])



  // AuditLog
  useEffect(async () => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    var menuDetail = await getMenuDetails(window.location.pathname + "?" + type)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push("/dashboard")

    await masterAuditLog(menu, LogUserType, LocationCode, CompanyCode) //masterfile access log


    const { success, data } = await GetHeaderReasonTypesCashBook(type)
    if (success) {
      setReasonTypes(data)
    } else {
      setReasonTypes([])
    }

  }, [type])


  useEffect(async () => {
    var txnData = await getPayTXNSetup(type)
    if (txnData.length > 0) {
      var data = txnData[0]
      setPayTxnSetup(data)
      setDispSalesExec(data.pY_SAACTIVE == 1 ? true : false)
      setDispSupplier(data.pY_SUPACTIVE == 1 ? true : false)
      setDispCustomer(data.pY_CUSACTIVE == 1 ? true : false)
      setDispMode(data.pY_MODEACTIVE == 1 ? true : false)
      setOverPay(data.pY_OVERPAY == 1 ? true : false)
      setAdvancePayment(data.pY_ADVANCEPAYMENT == 1 ? true : false)
      setPY_SUP_DISPLAY(data.pY_SUP_DISPLAY)
      setPY_SUP_SEARCH(data.pY_SUP_SEARCH)
      setPY_CUS_DISPLAY(data.pY_CUS_DISPLAY)
      setPY_CUS_SEARCH(data.pY_CUS_SEARCH)
      setPY_SA_DISPLAY(data.pY_SA_DISPLAY)
      setPY_SA_SEARCH(data.pY_SA_SEARCH)
    }
  }, [type])


  useEffect(async () => {
    TotalCalculation()
  }, [detailTable])

  useEffect(async () => {
    TotalPayCalculation()
  }, [rowsPay])

  function TotalCalculation() {
    let TotNetAmount = detailTable.reduce((sum, { netAmount }) => sum + parseFloat(netAmount), 0)
    let TotalDueAmount = detailTable.reduce((sum, { dueAmount }) => sum + parseFloat(dueAmount), 0)
    let TotalPayment = detailTable.reduce((sum, { payment }) => sum + parseFloat(payment), 0)
    let TotalPaidAmount = detailTable.reduce((sum, { paidAmount }) => sum + parseFloat(paidAmount), 0)

    setTotalPaymentAmout(parseFloat(TotalPayment).toFixed(txnDecimalAmt))
    setTotalNetAmount(parseFloat(TotNetAmount).toFixed(txnDecimalAmt))
    setTotalDueAmount(parseFloat(TotalDueAmount).toFixed(txnDecimalAmt))
    setTotalPaidAmount(parseFloat(TotalPaidAmount).toFixed(txnDecimalAmt))
  }


  const AutoAllocate = () => {
    let totalAmount = TotalPayValue
    let allocatedDetailTable = []

    detailTable.map((item, index) => {
      var newRow = item
      newRow.payment = parseFloat(item.dueAmount) > parseFloat(totalAmount) ? parseFloat(totalAmount).toFixed(txnDecimalAmt) : parseFloat(item.dueAmount).toFixed(txnDecimalAmt)
      allocatedDetailTable.push(newRow)
      totalAmount = item.dueAmount < totalAmount ? totalAmount - item.dueAmount : 0.00;
    })

    setDetailTable(allocatedDetailTable)
  }


  //Payment
  function TotalPayCalculation() {
    setTotalPayValue(parseFloat(rowsPay.reduce((sum, { payAmount }) => sum + parseFloat(payAmount), 0)).toFixed(txnDecimalAmt))
  }
  //Alert Parameter


  const handleCancel = async () => {

    let strResult = await setInvoiceCancel(
      strCode,
      LogUserType,
      menu,
      LogCompanyCode,
      LocationCode,
    )
    if (strResult.status == "200") {
      strResult.json().then(responseData => {

        if (responseData.data == "Record Already Exsist!") {
          displayAlertMessage('danger', responseData.data)
        } else if (responseData.data == "Code Already Exsist!") {
          displayAlertMessage('danger', responseData.data)
        } else {
          handleNew()
          displayAlertMessage('success', responseData.data)
        }
      })
    } else if (strResult.status == "400") {
      strResult.json().then(responseData => {
        displayAlertMessage('danger', responseData.msg)
      })
    } else {
      handleNew()
    }
  }

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }


  function tog_xlarge1() {
    setmodal_xlarge1(!modal_xlarge1)
    removeBodyCss()
  }

  function tog_xlarge_supplier() {
    setmodel_xlarge_supplier(!model_xlarge_supplier)
    removeBodyCss()
  }

  function tog_xlarge_customer() {
    setmodel_xlarge_customer(!model_xlarge_customer)
    removeBodyCss()
  }

  function tog_xlarge_saleExec() {
    setmodel_xlarge_saleExec(!model_xlarge_saleExec)
    removeBodyCss()
  }

  function tog_xlarge_location() {
    setmodel_xlarge_location(!model_xlarge_location)
    removeBodyCss()
  }

  function tog_xlarge_mode() {
    setmodel_xlarge_mode(!model_xlarge_mode)
    removeBodyCss()
  }

  //removebodyCss function
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }


  //save button function
  const handlesave = async (isProcessed) => {


    //url
    const url = window.location.href
    const urlArr = url.split("/CreditNote")
    const displayUrl = urlArr[0] + "/CreditNote"


    var newCode = ""

    if (addNew == true) {
      newCode = "NAN"
    } else {
      newCode = strCode
    }

    var PayDetails = []

    detailTable.forEach((item, index) => {
      if (item.document != "" && item.type != "") {
        PayDetails.push(TXNBuilder(
          newCode,
          item.id,
          item.type,
          item.document,
          item.date,
          item.reference,
          item.location,
          item.locationName,
          item.netAmount,
          item.dueAmount,
          item.payment
        ))
      }
    })


    var PaymentDet = []


    for (const item of rowsPay) {
      if (parseFloat(TotalPaymentAmout) != parseFloat(TotalDueAmount) && item.overpayEnable === true) {
        displayAlertMessage('danger', "Cannot do an overpayment using overpayment payment mode!")
        return
      } else if (item.paycode !== '' && item.payDetcode !== '') {
        PaymentDet.push(
          PaymentBuilder(
            newCode,
            item.paycode,
            item.payDetcode,
            item.accountCode,
            item.expDate,
            item.payAmount,
            item.printCheque,
            item.acPayee
          )
        )
      }
    }

    if (dispSupplier && strSupplier == '') {
      displayAlertMessage('danger', "Please Select " + PY_SUP_DISPLAY + " !")
      return
    }

    if (dispCustomer && strCustomer == '') {
      displayAlertMessage('danger', "Please Select " + PY_CUS_DISPLAY + " !")
      return
    }

    if (dispSalesExec && strSalesExec == '') {
      displayAlertMessage('danger', "Please Select " + PY_SA_DISPLAY + " !")
      return
    }

    if (strLocation == "") {
      displayAlertMessage('danger', "Please Select Location !")
      return
    }

    if (dispMode && strMode == '') {
      displayAlertMessage('danger', "Please Select Mode")
      return
    }

    if (!PaymentDet.length) {
      displayAlertMessage('danger', "Need to assign at least one Payment method !")
      return
    }

    if (advancePayment == false) {

      if (TotalPaymentAmout != TotalPayValue) {
        displayAlertMessage('danger', "Need to equal Pay Amount and Payment Amount!")
        return
      }

      if (!PayDetails.length) {
        displayAlertMessage('danger', "Need to assign at least one Item !")
        return
      }

    }

    let currentApprovals = []

    if (isProcessed == 1) {
      const RuleList = await GetRules(menuCode)

      if (RuleList.length > 0) {
        const RuleListData = await PaymentRuleValidation(RuleList, menuCode, TotalPayValue)
        if (RuleListData.length > 0) {
          currentApprovals = [...currentApprovals, ...RuleListData]
        }

      }

      if (strRemarks2 != "") {
        const response = await RemarkValidation(strRemarks2, LogUserType)

        if (response.isSuccess && response.data == false) {

          const reason = ReasonTypes.find(item => item.value == strRemarks2)

          currentApprovals.push({
            strRA_TXN_TYPE: type,
            strRA_TXN_NO: "NAN",
            strRA_TXN_LOCATION: strLocation,
            dtRA_TXN_DATE: new Date(),
            dcRA_TXN_VALUE: parseFloat(TotalPayValue),
            strRA_TXN_PERMISSION: `RC${strRemarks2}`,
            strRA_REQUEST: "Reason Type Permission! Reason: " + reason?.label ?? "",
            intRA_PRIORITY: 1,
            shrtRA_APPROVED: 0,
            strRA_APPRIVED_BY: "",
            strRA_REMARKS: "",
          })
        }
      }
    }

    const modifiedApprovals = currentApprovals.map((item, index) => {
      return {
        ...item,
        strRA_TXN_TYPE: type,
        strRA_TXN_LOCATION: strLocation,
        dtRA_TXN_DATE: new Date(),
        dcRA_TXN_VALUE: parseFloat(TotalPayValue),
        baseURL: displayUrl
      }
    })


    const approvedRules = approvalRequests.filter(item => item.shrtRA_APPROVED == 1)

    //skip approved rules from modifiredRemoteRequest

    const modifiredRemoteRequest = modifiedApprovals.filter(item => !approvedRules.some(approvedItem => approvedItem.strRA_TXN_PERMISSION == item.strRA_TXN_PERMISSION))

    let data = JSON.stringify({
      "HED_TYPE": type,
      "HED_RUNNO": strCode,
      "HED_COMCODE": LogCompanyCode,
      "HED_SETUPLOC": LocationCode,
      "HED_TXNDATE": new Date(),
      "HED_TIME": new Date(),
      "HED_PROCDATE": new Date(),
      "HED_CANDATE": new Date(),
      "HED_LOCATION": strLocation,
      "HED_SUPCODE": strSupplier,
      "HED_CUSCODE": strCustomer,
      "HED_SACODE": strSalesExec,
      "HED_RWMODE": strMode,
      "HED_REF1": strRemarks1,
      "HED_REF2": strRemarks2,
      "HED_TOTAMOUNT": parseFloat(TotalPayValue),
      "HED_NETAMT": parseFloat(TotalNetAmount),
      "HED_CRBY": LogUserType,
      "HED_MDBY": LogUserType,
      "HED_CANUSER": LogUserType,
      "HED_EXPBATCH": "1",
      "HED_PRINTCOUNT": parseFloat(0),
      "HED_RECCOUNT": parseFloat(0),
      "HED_REFCOUNT": parseFloat(0),
      "HED_PROCESSED": modifiredRemoteRequest.length > 0 ? 0 : isProcessed,
      "HED_CANCELLED": 0,
      "HED_FULLYUSED": 0,
      "HED_EXPORT": 0,
      "HED_LOCKED": 0,
      "MenuCode": menuCode,
      "LoggedCompany": LogCompanyCode,
      "LoggedLocation": LocationCode,
      "Reason": Reason,
      "PayDetails": PayDetails,
      "PayCollection": PaymentDet,
      "Attachments": Attachment(),	//Attachment
      "ApprovalRequests": modifiredRemoteRequest
    })

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Saving...")

    try {
      const response = await savePayTransaction(data);
      SetLoadingAlert(false)

      if (response.success) {

        displayAlertMessage('success', `Save Success!.Document No is ${response.data}`)
        SendPermisstionRequest(response.data) //send permission notification
        ClearItem()

      } else {
        displayAlertMessage('danger', response.message)
      }
    } catch (error) {
      console.log(error)
      SetLoadingAlert(false)
    }

  }


  const Attachment = () => {

    let TblLine = []
    attachFileNames.map((item, index) => {
      TblLine.push({
        lineNo: parseInt(item.lineNo),
        filePath: item.fileName,
      })
    })
    return TblLine
  }


  const SendPermisstionRequest = async (DocumentNo) => {
    var obj = JSON.parse(localStorage.getItem("authUser"))
    let LogUserType = obj[2]
    let LocationCode = obj[3]
    let LocationName = obj[4]
    var Body = {
      "strUserID": LogUserType,
      "strLocCode": LocationCode,
      "strLocName": LocationName,
      "strDocNo": DocumentNo,
      "strMenuCode": menuCode,
      "strTransaction": type,
      "txnType": "C"
    }
    SendFCM(Body);
  }

  const TXNBuilder = (
    newCode,
    i,
    txtType,
    txtDocument,
    txtDate,
    txtReference,
    txtLocation,
    txtLocationName,
    txtNetAmount,
    txtDueAmount,
    txtPayment
  ) => {
    return {
      DET_TYPE: type,
      DET_RUNNO: newCode,
      DET_COMCODE: LogCompanyCode,
      DET_SETUPLOC: LocationCode,
      DET_LINENO: parseFloat(i),
      DET_TRANTYPE: txtType,
      DET_DOCNO: txtDocument,
      DET_LOCATION: txtLocation,
      DET_NETAMOUNT: parseFloat(txtNetAmount),
      DET_DUEAMOUNT: parseFloat(txtDueAmount),
      DET_PAYAMOUNT: parseFloat(txtPayment),
    }
  }

  const PaymentBuilder = (
    newCode,
    txtPaycode,
    txtPaydetCode,
    txtAccountCode,
    txtExpDate,
    txtPayAmount,
    chequePrint,
    acPayee
  ) => {

    var date = new Date()
    date = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
    var newDate = new Date(date)
    return {
      PAYDET_TYPE: type,
      PAYDET_RUNNO: newCode,
      DET_COMCODE: LogCompanyCode,
      DET_SETUPLOC: LocationCode,
      PAYDET_PHCODE: txtPaycode,
      PAYDET_PDCODE: txtPaydetCode,
      PAYDET_REFNO: txtAccountCode,
      PAYDET_RATE: "0",
      PAYDET_PAYDATE: txtExpDate == "" ? newDate : txtExpDate,
      PAYDET_AMOUNT: parseFloat(txtPayAmount),
      PAYDET_CHQPRINT: chequePrint ? 1 : 0,
      PAYDET_ACPAYEE: acPayee,
      PAYDET_LOCATION: LocationCode
    }

  }
  //*** Get user selected row details */
  const GetSelectRow = (row, isSelect, rowIndex, e) => {
    SetCode(row.code)
    ValueSetter(row.code)
    setmodal_xlarge(!modal_xlarge)

  }

  const GetSelectRow1 = async (e, row, isSelect, rowIndex) => {
    SetCode(row.HED_RUNNO)
    setmodal_xlarge(false)
    GetDocumentData(row.HED_RUNNO)
  }


  const GetDocumentData = async (code) => {

    if (code == "") return

    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var loginLocation = obj[3]

    try {


      SetLoadingAlert(true)
      SetLoadingAlerttitle("Loading...")

      var result = await GetPayTransaction(type, code, loginLocation)

      SetLoadingAlert(false)

      if (result.response == true) {
        setmodal_xlarge(false)
        setSaveEnable(false)
        var data = result.data
        var txndate = new Date(data.heD_TXNDATE.slice(0, 10)).toISOString().split("T")[0]
        SetblDiasableGrid(true)
        setDisabled(true)
        SetCode(data.heD_RUNNO)
        SetCustomer(data.heD_CUSCODE)
        SetCustomerName(data.cM_FULLNAME)
        SetSupplier(data.heD_SUPCODE)
        SetSupplierName(data.sM_NAME)
        SetSalesExec(data.heD_SACODE)
        SetSalesExecName(data.sA_FULLNAME)
        SetLocation(data.heD_LOCATION)
        SetLocationName(data.loC_DESC)
        SetMode(data.heD_RWMODE)
        SetModeName(data.rW_DESC)
        SetRemarks1(data.heD_REF1)
        SetRemarks2(data.heD_REF2)
        SetDate(txndate)
        setCrBy(data.createdBy)
        setMdBy(data.modifiedBy)
        setCrDate(data.createdDate)
        setMdDate(data.modifiedDate)
        setCrEnable(true)
        setClearAttachmentEdit(prev => !prev)
        setAttachFileNames(data.attachments)
        SetAddNew(false)

        setPrintEnable(true)
        setApprovalRequests(data.approvalRequest)


        setTabList([
          {
            text: "General",
            icon: "fas fa-home",
            tabID: "1",
            onClick: () => {
              toggleCustom("1")
            },
          },
          {
            text: "Document",
            icon: "far fa-user",
            tabID: "2",
            onClick: () => {
              toggleCustom("2")
            },
          }, {
            text: "Approvals",
            icon: "fas fa-paperclip",
            tabID: "3",
            onClick: () => {
              toggleCustom("3")
            }
          }
        ])

        const modifiedDetailRow = data.payTransactions.map((item, index) => {
          item.id = index + 1
          return item
        })

        setDetailTable(modifiedDetailRow)

        const modifiedPaymentRow = data.paymentDetailsSelect.map((item, index) => {
          item.id = index + 1
          item.payDetDisable = true
          item.paymodeEnable = true

          item.overpayEnable = false
          item.overpayValue = 0
          item.isPaymodeDetail = false
          item.dateDisable = true

          return item
        })
        setRowsPay(modifiedPaymentRow)
        setIsDocProcessed(data.heD_PROCESSED == 1 ? "Yes" : "No")

        if (data.heD_PROCESSED == 0) {
          setEditEnable(true)
        }

        setProcessDisable(true)

      } else {
        displayAlertMessage('danger', `Record not found`)
        SetCode("")
      }
    } catch (error) {
      console.log(error)
      SetLoadingAlert(false)
    }
  }



  const GetSelectRowSupplier = (e, row, isSelect, rowIndex) => {

    SetSupplier(row[PY_SUP_SEARCH])
    SetSupplierName(row.SM_NAME)
    setmodel_xlarge_supplier(!model_xlarge_supplier)
    setGen_Vendor_Disabled(true)
  }

  const GetSelectRowCustomer = (e, row, isSelect, rowIndex) => {

    SetCustomer(row[PY_CUS_SEARCH])
    SetCustomerName(row.CM_FULLNAME)
    setmodel_xlarge_customer(!model_xlarge_customer)
    setGen_Customer_Disabled(true)
  }

  const GetSelectRowSalesExec = (e, row, isSelect, rowIndex) => {

    SetSalesExec(row[PY_SA_SEARCH])
    SetSalesExecName(row.SA_FULLNAME)
    setmodel_xlarge_saleExec(!model_xlarge_saleExec)
    setGen_SalesExec_Disabled(true)
  }

  const GetSelectRowLocation = (e, row, isSelect, rowIndex) => {

    SetLocation(row.LOC_CODE)
    SetLocationName(row.LOC_DESC)
    setmodel_xlarge_location(!model_xlarge_location)
    setGen_Location_Disabled(true)
  }

  const GetSelectRowMode = (e, row, isSelect, rowIndex) => {

    SetMode(row.RW_CODE)
    SetModeName(row.RW_DESC)
    setmodel_xlarge_mode(!model_xlarge_mode)
    setGen_Mode_Disabled(true)
  }

  // const LoadBalOrder = async code => {

  //   let Balancedata = await getBalanceOrderSheet(LocationCode, code)
  //   if (Balancedata.length > 0) {
  //     setPermissionName(LogUserType)
  //     setPermissionReasonShow(true)
  //     setPermissionNameDisable(true)
  //     setPermissionAlertShow(true)
  //     setmodal_xlarge1(!modal_xlarge1)
  //   }
  //   else {
  //     ValueSetter1(code)
  //     setmodal_xlarge1(!modal_xlarge1)
  //   }
  // }


  const toggleCustom = tab => {
    setcustomActiveTab(tab)
  }


  //edit button function
  const handleEdit = async (e) => {


    if (approvalRequests.length > 0) {
      const { approvalStatus, alertMessage } = await getApprovalStatusAndMessage(approvalRequests);

      if (approvalStatus === 0) {
        displayAlertMessage("warning", alertMessage || "Pending approvals should be approved or rejected before amending this document!");
        return;
      } else if (approvalStatus === 2) {
        displayAlertMessage("danger", alertMessage || "Sorry! Your request to approve was rejected. This document is not editable.");
        return;
      } else if (approvalStatus === 1 || approvalStatus === 3) {
        displayAlertMessage("info", alertMessage);
      }

      if (approvalStatus == 3) {
        SetblDiasableGrid(false);
      } else {
        SetblDiasableGrid(true);
      }

      setSaveEnable(true)
      setEditEnable(false)
      setProcessDisable(isDocProcessed == "Yes" ? true : false)
    } else {
      setSaveEnable(true)
      setEditEnable(false)
      SetblDiasableGrid(false);
      setProcessDisable(isDocProcessed == "Yes" ? true : false)

    }


    // setSaveEnable(true)
    // setEditEnable(false)
    // setProcessDisable(isDocProcessed == "Yes" ? true : false)
  }

  //new button function
  const handleNew = e => {
    ClearItem()
    setAlertShow(false)
    setAlertMsg(false)
    setSaveEnable(true)

  }
  Date.prototype.addDays = function (days) {
    this.setDate(this.getDate() + parseInt(days));
    return this;
  };
  //clear fields function
  const ClearItem = () => {
    var currentDate = new Date();

    SetCode("") // Set Code
    SetDate(new Date(currentDate).toISOString().split("T")[0])
    SetCustomer("")
    SetRemarks1("")
    SetRemarks2("")
    SetAddress1("")
    SetAddress2("")
    SetAddress3("")
    SetDeliveryline1("")
    SetDeliveryline2("")
    SetDeliveryline3("")
    SetMobileNo("")
    SetEmail("")
    SetPayRemarks1("")
    setProcessStatus(0)
    setIsDocProcessed("")
    SetActive(true)
    SetdbSellingAmount("0.0")
    SetdbGrossAmount("0.0")
    SetdbDiscountPer("0.0")
    SetdbNetAmount("0.0")
    setTotalBookQty("0.0")
    setTotalCostValue("0.0")
    setTotalSellingValue("0.0")
    setTotalPayValue("0.0")
    SetrOrderNo("")
    SetOrderStatus("")
    SetAddNew(true)
    SetDeleteEnable(false)
    setClearAttachmentEdit(prev => !prev)
    setAttachFileNames([])
    setcustomActiveTab("1")
    setEditEnable(false)
    SetblDiasableGrid(false)
    setShowTaxTable(false)
    SetCodeEnable(false)
    SetDateEnable(false)
    SetCustomerEnable(false)
    SetRemarks1Enable(false)
    setSaveEnable(true)
    setCrEnable(false)
    SetOrderNoEnable(false)
    SetDeliveryline1Enable(false)
    SetDeliveryline2Enable(false)
    SetDeliveryline3Enable(false)
    SetOrderStatusEnable(false)
    setPrintEnable(false)
    setCancelEnable(false)
    setDisabled(false)
    SetCustomer("")
    SetCustomerName("")
    SetSupplier("")
    SetSupplierName("")
    SetSalesExec("")
    SetSalesExecName("")
    SetLocation("")
    SetLocationName("")
    SetMode("")
    SetModeName("")
    setDisableTransBTN(false)
    setTotalPaymentAmout(parseFloat(0).toFixed(txnDecimalAmt))
    setTotalNetAmount(parseFloat(0).toFixed(txnDecimalAmt))
    setTotalDueAmount(parseFloat(0).toFixed(txnDecimalAmt))
    setTotalPaidAmount(parseFloat(0).toFixed(txnDecimalAmt))
    setGen_Vendor_Disabled(false)
    setGen_Customer_Disabled(false)
    setGen_SalesExec_Disabled(false)
    setGen_Location_Disabled(false)
    setGen_Mode_Disabled(false)
    setProcessDisable(false)
    setApprovalRequests([])
    setTabList([
      {
        text: "General",
        icon: "fas fa-home",
        tabID: "1",
        onClick: () => {
          toggleCustom("1")
        },
      },
      {
        text: "Document",
        icon: "far fa-user",
        tabID: "2",
        onClick: () => {
          toggleCustom("2")
        },
      }
    ])

    setDetailTable(DetailObj)
    setRowsPay([{
      paycode: "",
      paydesc: "",
      payDetcode: "",
      payDetName: "",
      payAmount: 0,
      accountCode: "",
      expDate: "",
      overpayEnable: false,
      paymodeEnable: false,
      overpayValue: 0,
      isPaymodeDetail: false,
      printCheque: false,
      acPayee: "",
      dateDisable: true,
      payDetDisable: true,
      refType: "",
      refCheck: 0,
      id: 1
    }])

  }

  // Set values to variables(Data Recall main method)
  const ValueSetter = async code => {

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Fetching...")

    let Data = await getQuotationDetails(code, LocationCode)

    SetLoadingAlert(false)

    if (Data.success == true) {
      Data.map(dr => {

        let modifiedRows = []
        let modifiedRowsPay = []

        setCrEnable(true)
        setSaveEnable(false)

        SetDate(dr.dtValidityDate)
        SetCustomer(dr.customerCode)
        SetRemarks1(dr.strRemarks)
        SetMobileNo(dr.mobileNo)
        SetAddress1(dr.customerAddress1)
        SetAddress2(dr.customerAddress2)
        SetAddress3(dr.customerAddress3)
        SetDeliveryline1(dr.deliveryAddress1)
        SetDeliveryline2(dr.deliveryAddress2)
        SetDeliveryline3(dr.deliveryAddress3)
        SetEmail(dr.email)
        SetrOrderNo(dr.refNo)
        SetPayRemarks1(dr.strPayRemark)
        if (dr.intPaid == 0) {
          SetActive(false)
        } else if (dr.orderStatus == 1) {
          SetActive(true)
        }

        if (dr.orderStatus == "P") {
          SetOrderStatus("Pickup")
        } else if (dr.orderStatus == "D") {
          SetOrderStatus("Delivery")
        }
        let TotNoOfBook = 0;
        let TotCostValue = 0;
        let TotSellingValue = 0;
        dr.invoiceDETAIL.map(dr => {
          TotNoOfBook = parseFloat(TotNoOfBook) + parseFloat(dr.deT_UNITQTY);
          TotCostValue = parseFloat(TotCostValue) + parseFloat(dr.deT_DISCAMT);
          TotSellingValue = parseFloat(TotSellingValue) + parseFloat(dr.deT_AMOUNT);
        })
        setTotalBookQty(TotNoOfBook)
        setTotalCostValue(TotCostValue)
        setTotalSellingValue(TotSellingValue)
        setTotalPayValue(TotSellingValue)

        dr.invoiceDETAIL.map(dr => {
          modifiedRows.push({
            id: dr.deT_LINENO,
            code: dr.deT_PROCODE,
            desc: dr.deT_PRODESC,
            Selling: dr.deT_SPRICE,
            Qty: dr.deT_UNITQTY,
            Discount: dr.deT_DISCAMT,
            LineAmount: dr.deT_AMOUNT,

          })
        })
        setDetailTable(modifiedRows)

        dr.invPayDETAIL.map(dr => {
          modifiedRowsPay.push({
            Paycode: dr.deT_PAYCODE,
            Paydesc: dr.deT_PAYNAME,
            PayAmount: dr.deT_AMOUNT,
            PayDetcode: dr.deT_PAYDETCODE,
            PayDetName: dr.deT_PAYDETNAME,
            AccountCode: dr.deT_ACCOUNTNO,
          })
        })
        setRowsPay(modifiedRowsPay)

        SetdbGrossAmount(TotSellingValue)
        SetdbDiscountPer(dr.discountPer)
        SetdbNetAmount(dr.netAmount)
        setCrBy(dr.createdBy)
        setMdBy(dr.modifiedDate)
        setCrDate(dr.createdDate)
        setMdDate(dr.modifiedBy)

        SetblDiasableGrid(true)

        SetCodeEnable(true)
        SetDateEnable(true)
        SetCustomerEnable(true)
        SetRemarks1Enable(true)
        SetDeliveryline1Enable(true)
        SetDeliveryline2Enable(true)
        SetDeliveryline3Enable(true)
        //SetOrderStatusEnable(true)
        SetOrderNoEnable(true)
        setCancelEnable(true)
        SetAddNew(false)

      })
    } else {
      displayAlertMessage('success', 'Record Not Found !')
    }
  }


  // Set values to variables(Data Recall main method)
  const ValueSetter1 = async code => {

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Fetching...")

    let Data = await getPendingOrderSheetDetails(code, LocationCode)

    SetLoadingAlert(false)

    if (Data.success == true) {
      Data.map(dr => {
        setDetailTable([])
        let modifiedRows = []

        setCrEnable(true)
        setSaveEnable(false)
        SetDate(dr.dtValidityDate)
        SetCustomer(dr.customerCode)
        SetRemarks1(dr.strRemarks)
        SetMobileNo(dr.mobileNo)
        SetAddress1(dr.customerAddress1)
        SetAddress2(dr.customerAddress2)
        SetAddress3(dr.customerAddress3)
        SetDeliveryline1(dr.deliveryAddress1)
        SetDeliveryline2(dr.deliveryAddress2)
        SetDeliveryline3(dr.deliveryAddress3)
        SetEmail(dr.email)

        if (dr.orderStatus == "P") {
          SetOrderStatus("Pickup")
        } else if (dr.orderStatus == "D") {
          SetOrderStatus("Delivery")
        }
        let TotNoOfBook = 0;
        let TotCostValue = 0;
        let TotSellingValue = 0;
        dr.salesConfirmationDETAIL.map(dr => {
          TotNoOfBook = parseFloat(TotNoOfBook) + parseFloat(dr.deT_UNITQTY);
          TotCostValue = parseFloat(TotCostValue) + parseFloat(dr.deT_DISCAMT);
          TotSellingValue = parseFloat(TotSellingValue) + parseFloat(dr.deT_AMOUNT);
        })
        setTotalBookQty(TotNoOfBook)
        setTotalCostValue(TotCostValue)
        setTotalSellingValue(TotSellingValue)


        dr.salesConfirmationDETAIL.map(dr => {
          modifiedRows.push({
            id: dr.deT_LINENO,
            code: dr.deT_PROCODE,
            desc: dr.deT_PRODESC,
            Selling: dr.deT_SPRICE,
            Qty: dr.deT_UNITQTY,
            Discount: dr.deT_DISCAMT,
            Discountper: dr.deT_DISCPER,
            LineAmount: dr.deT_AMOUNT,

          })
        })
        setDetailTable(modifiedRows)


        SetdbGrossAmount(TotSellingValue)
        SetdbDiscountPer(dr.discountPer)
        SetdbNetAmount(TotSellingValue)


        SetblDiasableGrid(false)

        SetCodeEnable(true)
        SetDateEnable(true)
        SetCustomerEnable(true)
        SetRemarks1Enable(false)

        SetAddNew(false)
      })
    } else {
      displayAlertMessage('success', 'Record Not Found !')
    }
  }

  //modal props
  const columns = [
    {
      dataField: "id",
      text: "Id",
      sort: true,
    },
    {
      dataField: "code",
      text: "Order Number",
      sort: true,
    },
    {
      dataField: "CustomerName",
      text: "Customer Name",
      sort: true,
    },
    {
      dataField: "MobileNo",
      text: "Mobile No",
      sort: true,
    },
    {
      dataField: "dtDate",
      text: "Date",
      sort: true,
    },
    {
      dataField: "strRemarks",
      text: "Special Remark",
      sort: true,
    },
    {
      dataField: "NetAmount",
      text: "Net Amount",
      sort: true,
    },

  ]

  //default sorted method
  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]


  function tog_xlargeSup() {
    setmodal_xlargeSup(!modal_xlargeSup)
    removeBodyCss()
  }


  function CustomerCodeSearch(value) {

    if (value != "") {
      const ApiURL = window.Links.ApiURL
      fetch(`${ApiURL}Customer/Search/${value}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      })
        .then(Response => Response.json())
        .then(responseData => {
          if (responseData.success == true) {

            const newArray = responseData.data[0]
            SetCustomer(newArray.code)
            SetMobileNo(newArray.mobileNo)
            SetAddress1(newArray.address1)
            SetAddress2(newArray.address2)
            SetAddress3(newArray.address3)
            SetEmail(newArray.email)
            SetDeliveryline1(newArray.address1)
            SetDeliveryline2(newArray.address2)
            SetDeliveryline3(newArray.address3)

          }
          else {
            SetCustomer("")
          }
        })
    }
    else {
      SetCustomer("")
    }
  }




  // print Function
  const handlePrint = async (option) => {
    try {
      SetLoadingAlert(true);
      SetLoadingAlerttitle("Generating Report...");

      const ReportURL = window.Links.ReportURL;

      // Fetch report data
      const response = await fetch(
        `${ReportURL}api/CreditNote/report/${option === "PDF" ? 1 : 0}/${LogUserType}/${strCode}/${type}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const responseData = await response.json();

      if (responseData.success) {
        const fileExtension = option === "PDF" ? "pdf" : "xls";
        const fileName = responseData.msg.replace("\r\n", "");

        window.open(`${ReportURL}temp_print/${fileName}.${fileExtension}`);
      }

    } catch (error) {
      console.error("Error generating report:", error.message);
      // Optionally, notify the user of the error
      SetLoadingAlert(false);
    } finally {
      SetLoadingAlert(false);
    }
  };


  const handlePrintCheque = async (PHCode, PDCode, ACNO) => {
    try {
      SetLoadingAlert(true);
      SetLoadingAlerttitle("Generating Report...");

      const ReportURL = window.Links.ReportURL;

      // Fetch report data
      const response = await fetch(
        `${ReportURL}api/CreditNote/reportCheque/${type}/${strCode}/${PHCode}/${PDCode}/${ACNO}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const responseData = await response.json();

      if (responseData.success) {
        const fileName = responseData.msg.replace("\r\n", "");
        window.open(`${ReportURL}temp_print/${fileName}.pdf`);
      }

    } catch (error) {
      console.error("Error generating report:", error.message);
      // Optionally, notify the user of the error
      SetLoadingAlert(false);
    } finally {
      SetLoadingAlert(false);
    }
  };


  async function Gen_LoadInvoices() {

    var supplier = strSupplier == "" ? "0" : strSupplier
    var customer = strCustomer == "" ? "0" : strCustomer
    var saleExec = strSalesExec == "" ? "0" : strSalesExec
    var mode = strMode == "" ? "0" : strMode
    var locaion = strLocation == "" ? "0" : strLocation

    if (dispSupplier && strSupplier == "") {
      displayAlertMessage('danger', "Please Select " + PY_SUP_DISPLAY + " !")
      return
    }

    if (dispCustomer && strCustomer == "") {
      displayAlertMessage('danger', "Please Select " + PY_CUS_DISPLAY + " !")
      return

    }

    if (dispSalesExec && strSalesExec == "") {
      displayAlertMessage('danger', "Please Select " + PY_SA_DISPLAY + " !")
      return
    }

    if (dispMode && strMode == "") {
      displayAlertMessage('danger', "Please Select Mode !")
      return
    }


    var data = await LoadPAYTXNDetails(type, customer, supplier, locaion)

    if (data.length == 0) {
      displayAlertMessage('danger', "No Data Found !")
      return
    } else {
      setDisableTransBTN(true)
    }


    CalculateTransactionTotal(data)

  }

  function CalculateTransactionTotal(data) {
    var TotalPayment = parseFloat(0).toFixed(txnDecimalAmt)
    var TotNetAmount = parseFloat(0).toFixed(txnDecimalAmt)
    var TotalDueAmount = parseFloat(0).toFixed(txnDecimalAmt)
    var TotalPaidAmount = parseFloat(0).toFixed(txnDecimalAmt)

    if (data.length > 0) {

      data.map((localState) => {
        TotalPayment = parseFloat(TotalPayment) + parseFloat(localState.payment)
        TotNetAmount = parseFloat(TotNetAmount) + parseFloat(localState.netAmount)
        TotalDueAmount = parseFloat(TotalDueAmount) + parseFloat(localState.dueAmount)
        TotalPaidAmount = parseFloat(TotalPaidAmount) + parseFloat(localState.paidAmount)
      })

      setTotalPaymentAmout(parseFloat(TotalPayment).toFixed(txnDecimalAmt))
      setTotalNetAmount(parseFloat(TotNetAmount).toFixed(txnDecimalAmt))
      setTotalDueAmount(parseFloat(TotalDueAmount).toFixed(txnDecimalAmt))
      setTotalPaidAmount(parseFloat(TotalPaidAmount).toFixed(txnDecimalAmt))

    } else {
      setTotalPaymentAmout(parseFloat(TotalPayment).toFixed(txnDecimalAmt))
      setTotalNetAmount(parseFloat(TotNetAmount).toFixed(txnDecimalAmt))
      setTotalDueAmount(parseFloat(TotalDueAmount).toFixed(txnDecimalAmt))
      setTotalPaidAmount(parseFloat(TotalPaidAmount).toFixed(txnDecimalAmt))
    }

    data.map((item, index) => {
      item.id = index + 1
    })

    setDetailTable(data)

  }


  const permission = (operation) => {

    const ApiURL = window.Links.ApiURL
    const permissiondata = {
      "strUsername": permissionName,
      "strPassword": permissionPassword,
      "strLocation": LocationCode,
      "strMenuCode": menuCode
    }

    fetch(`${ApiURL}login/userpermission`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify(permissiondata)
      }
    ).then(Response => {
      if (Response.status == "200") {
        Response.json()
          .then(responseData => {

            let Access = (responseData.data.strMenuAccessRight)
            let Create = (responseData.data.strMenuCreateRight)
            let Delete = (responseData.data.strMenuDeleteRight)
            let Modify = (responseData.data.strMenuModifyRight)
            let Print = (responseData.data.strMenuPrintRight)
            let Process = (responseData.data.strMenuProcessRight)

            if (operation == "Save") {
              if (Create == true) {
                handlesave(processStatus)
              } else if (Modify == true) {
                handlesave(processStatus)
              } else {
                if (operation == "Save" && addNew == true) {
                  displayAlertMessage('danger', "This user dosen't have permission to save")
                } else {
                  displayAlertMessage('danger', "This user dosen't have permission to edit")
                }
              }
            } else if (operation == "Delete") {
              if (Delete == true) {
                handleDelete()
              } else {
                displayAlertMessage('danger', "This user don't have permission to delete !")
              }
            } else if (operation == "Print") {
              if (Print == true) {
                setprintoptionShow(true)
              } else {
                displayAlertMessage('danger', "This user don't have permission to print !")
              }
            }
          }
          )

      } else if (Response.status == "400") {
        setDisabled(false)
        clearPermissionInputs()
        displayAlertMessage('danger', "Oops something went wrong !")

      } else if (Response.status == "403") {
        setDisabled(false)
        clearPermissionInputs()
        displayAlertMessage('danger', "You have not Permission to make changes !")

      } else if (Response.status == "404") {
        setDisabled(false)
        clearPermissionInputs()
        displayAlertMessage('danger', "Password or User Name is Invalid !")

      } else {
        ClearItem()
      }
    }).catch(error => {
      console.log(error.message)
    }).finally(() => {
      setPermissionAlertShow(false)
      setPermissionNameDisable(false)
      setPermissionName("")
      setPermissionPassword("")
      setReason("")
    })
  }

  //Handle Favourite Button
  const handleFavourite = async () => {
    var response = await addtoFavourite(menuCode, LogUserType);
  }


  //Function for display Alert Messages
  function displayAlertMessage(color, message) {
    setAlertColor(color)
    setAlertMsg(message)
    setAlertShow(true)

    setTimeout(() => {
      setAlertShow(false)
    }, time)
  }


  //Clear permission name & password
  function clearPermissionInputs() {
    setPermissionName("");
    setPermissionPassword("");
    setReason("");
  }



  //handle permission alert
  function handlePermissionAlert(LogUserType = "", reason = "", disable = false, alertShow = false) {
    setPermissionName(LogUserType)
    setReason(reason)
    setPermissionNameDisable(disable)
    setPermissionAlertShow(alertShow)
  }




  return (
    <React.Fragment>
      <div className="page-content">

        <MetaTags>
          <title>{menuName}</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumb
            title={parentName}
            breadcrumbItem={menuName}
          ></Breadcrumb>
          <DPAlert
            confirm_both={sweetAlertShow}
            title={menuName}
            description={AlertDescription}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            onConfirm={() => {
              setsweetAlertShow(false)
              if (AlertConfirmOption == 1) {
                setAlertConfirmOption(7)
                setAlertDescription("Do you wish to process this document ?")
                setsweetAlertShow(true)
              } else if (AlertConfirmOption == 2) {
                handleEdit()
              } else if (AlertConfirmOption == 3) {
                window.location.href = "/";
              } else if (AlertConfirmOption == 4) {
                handleNew()
              } else if (AlertConfirmOption == 5) {

                if (addNew == false && menuDelete == true && permissionReasonShow == false) {
                  handleDelete()
                } else if (addNew == false && menuDelete == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Deleted", true, true)
                } else {
                  setReason("")
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }
              } else if (AlertConfirmOption == 6) {
                if (menuPrint == true && permissionReasonShow == false) {
                  setprintoptionShow(true)
                } else if (menuPrint == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Prnited", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }
              } else if (AlertConfirmOption == 7) {
                setProcessStatus(1)
                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                  handlesave(1)
                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Created", true, true)
                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                  handlesave(1)
                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Updated", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }

              }
            }}
            onCancel={() => {
              setsweetAlertShow(false)

              if (AlertConfirmOption == 7) {
                setProcessStatus(0)
                if (addNew == true && menuCreate == true && permissionReasonShow == false) {
                  handlesave(0)
                } else if (addNew == true && menuCreate == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Created", true, true)
                } else if (addNew == false && menuModify == true && permissionReasonShow == false) {
                  handlesave(0)
                } else if (addNew == false && menuModify == true && permissionReasonShow == true) {
                  handlePermissionAlert(LogUserType, "Updated", true, true)
                } else {
                  setPermissionReasonShow(true)
                  setPermissionAlertShow(true)
                }

              }

            }}
          />
          <DPPermission
            confirm_both={permissionAlertShow}
            title={menuName}
            description={permissionAlertTitle}
            showReason={permissionReasonShow}
            nameDisable={permissionNameDisable}
            showCancel={true}
            btnColor={"success"}
            cancelColor={"danger"}
            AlName={permissionName}
            AlNameOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setPermissionName(val2)
            }}
            AlPassward={permissionPassword}
            AlPasswardOnchange={e => {
              let val2 = Text(e.target, 50, true, true, "any", true)
              setPermissionPassword(val2)
            }}
            AlReason={Reason}
            AlReasonOnchange={e => {
              let val2 = Text(e.target, 50, true, false, "any", true)
              setReason(val2)
            }}
            onConfirm={() => {
              setPermissionAlertShow(false)
              if (AlertConfirmOption == 1) {
                permission("Save")
              } else if (AlertConfirmOption == 5) {
                permission("Delete")
              } else if (AlertConfirmOption == 6) {
                permission("Print")
              } else if (AlertConfirmOption == 7) {
                permission("Save")
              }
            }}
            onCancel={() => {
              setPermissionAlertShow(false)
              clearPermissionInputs()
            }}
          />
          <DPLoadingAlert
            confirm_both={loadingAlert}
            title={loadingAlertTitle}
          />

          <DPPrintOption
            confirm_both={printoptionShow}
            title={menuName}
            showCancel={true}
            cancelColor={"danger"}
            onConfirmpdf={() => {
              handlePrint("PDF")
              setprintoptionShow(false)
            }}
            onConfirmxcel={() => {
              handlePrint("XCEL")
              setprintoptionShow(false)
            }}
            onCancel={() => {
              setprintoptionShow(false)
            }}
          />

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <DPTopToolBar
                    //Help Button
                    helpEnable={helpUrl != "" ? true : false}
                    helpClick={() => {
                      window.open(helpUrl)
                    }}
                    //Favorite Button
                    favoriteEnable={true}
                    favoriteClick={handleFavourite}
                    //New Button
                    newEnable={true}
                    newClick={() => {
                      setAlertDescription("Do you wish to refresh the screen ?")
                      setAlertConfirmOption(4)
                      setsweetAlertShow(true)
                    }}
                    //Save Button
                    saveEnable={saveEnable}
                    saveClick={() => {
                      setAlertDescription("Do you wish to save ?")
                      setAlertConfirmOption(1)
                      setsweetAlertShow(true)
                    }}
                    //ProcessButton
                    processEnable={false}
                    processClick={() => {
                      alert("Process")
                    }}
                    //Edit Button
                    editEnable={editEnable}
                    editClick={() => {
                      setAlertDescription("Do you wish to edit ?")
                      setAlertConfirmOption(2)
                      setsweetAlertShow(true)
                    }}
                    //Print Button
                    printEnable={PrintEnable}
                    printClick={() => {
                      setAlertDescription("Do you wish to Print ?")
                      setAlertConfirmOption(6)
                      setsweetAlertShow(true)
                    }}
                    //Delete Button
                    deleteEnable={CancelEnable}
                    deleteClick={() => {
                      setAlertDescription("Do you wish to Cancel ?")
                      setAlertConfirmOption(5)
                      setsweetAlertShow(true)
                    }}
                    //Exit Button
                    exitEnable={true}
                    exitClick={() => {
                      setAlertDescription("Do you wish to exit ?")
                      setAlertConfirmOption(3)
                      setsweetAlertShow(true)
                    }}
                  />

                  <DPNavBar buttons={tabList} activeStatus={customActiveTab} />
                  <Row>
                    <TabContent activeTab={customActiveTab} className="p-3 text">
                      {isDocProcessed != "" ? (
                        <Alert
                          color={isDocProcessed == "Yes" ? "dark" : "dark"}
                          role="alert"
                        >
                          {isDocProcessed == "Yes" ? "Processed Document !" : "Unprocessed Document !"}
                        </Alert>
                      ) : null}
                      {AlertShow ? (
                        <Alert color={AlertColor} role="alert">
                          {AlertMsg}
                        </Alert>
                      ) : null}
                      <TabPane tabId="1">
                        <Row>
                          <CreditNoteContent
                            menuCode={menuCode}
                            Gen_DataSearch={async () => {
                              tog_xlarge()
                            }}
                            DataTables={DataTables}
                            Hed_CodeSearchOpen={modal_xlarge}
                            Hed_CodeSearchTrigger={tog_xlarge}
                            AlertColor={AlertColor}
                            AlertMsg={AlertMsg}
                            Gen_Code={strCode}
                            Gen_Code_OnChange={e => {
                              let valCode = Text(e.target, 20, true, false, "upper", false)
                              SetCode(valCode)
                            }}
                            Gen_Code_onBlur={e => {
                              GetSelectRow1(e, { HED_RUNNO: e.target.value }, '', '')
                            }}
                            Gen_Code_Enabled={blCodeEnable}
                            Gen_Customer={strCustomer}
                            Gen_Customer_OnChange={e => {
                              SetCustomer(e.target.value)
                            }}
                            Gen_Customer_onBlur={e => {
                              CustomerCodeSearch(e.target.value)
                            }}
                            Gen_CustomerSearch={async () => {
                              tog_xlargeSup()
                            }}
                            SearchModelOpenCustomer={modal_xlargeSup}
                            SearchModelTriggerCustomer={tog_xlargeSup}
                            SearchGetSelectRowCustomer={GetSelectRowCustomer}
                            SearchGetSelectRowSupplier={GetSelectRowSupplier}
                            SearchGetSelectRowSalesExec={GetSelectRowSalesExec}
                            SearchGetSelectRowLocation={GetSelectRowLocation}
                            GetSelectRowMode={GetSelectRowMode}

                            Gen_MobileNo={strMobileNo}
                            Gen_MobileNo_OnChange={blMobileNoEnable}
                            Gen_TxnDate={strDate}
                            Gen_TxnDate_OnChange={e => {
                              SetDate(e.target.value)
                            }}
                            Gen_TxnDate_Enabled={blDateEnable}
                            Gen_Remark1={strRemarks1}
                            Gen_Remark1_OnChange={e => {
                              let valCode = Text(e.target, 50, true, true, "any", true)
                              SetRemarks1(valCode)
                            }}
                            Gen_Remark1_Enabled={blRemarks1Enable}
                            Gen_Deliveryline1={strDeliveryline1}
                            Gen_Deliveryline1_OnChange={e => {
                              let valCode = Text(e.target, 50, true, true, "any", true)
                              SetDeliveryline1(valCode)
                            }}
                            Gen_Deliveryline1_Enabled={blDeliveryline1Enable}
                            Gen_Deliveryline2={strDeliveryline2}
                            Gen_Deliveryline2_OnChange={e => {
                              let valCode = Text(e.target, 50, true, true, "any", true)
                              SetDeliveryline2(valCode)
                            }}
                            Gen_Deliveryline2_Enabled={blDeliveryline2Enable}
                            Gen_Deliveryline3={strDeliveryline3}
                            Gen_Deliveryline3_OnChange={e => {
                              let valCode = Text(e.target, 50, true, true, "any", true)
                              SetDeliveryline3(valCode)
                            }}
                            Gen_Deliveryline3_Enabled={blDeliveryline3Enable}
                            SearchDataTables={DataTables}
                            SearchColumns={columns}
                            SearchDefaultSorted={defaultSorted}
                            SearchModelOpen={modal_xlarge}
                            SearchModelTrigger={tog_xlarge}
                            SearchGetSelectRow={GetSelectRow}
                            menuName={menuName}
                            Type={type}
                            Gen_Email={strEmail}
                            Gen_CusLine1={strAddress1}
                            Gen_CusLine2={strAddress2}
                            Gen_CusLine3={strAddress3}
                            CheckStatus={strOrderStatus}
                            Gen_OrderStatus_Enabled={blOrderStatusEnable}
                            handleChange={e => {
                              if (blCodeEnable == false) {
                                SetOrderStatus(e.target.value)
                              }
                            }}
                            SearchDataTables1={DataTables1}
                            SearchColumns1={columns}
                            SearchDefaultSorted1={defaultSorted}
                            SearchModelOpen1={modal_xlarge1}
                            SearchModelTrigger1={tog_xlarge1}
                            SearchGetSelectRow1={GetSelectRow1}
                            Gen_OrderSheet_Enabled={blOrderNoEnable}
                            Gen_OrderSheet={strOrderNo}
                            Gen_OrderSheet_OnChange={e => {
                              let valCode = Text(e.target, 50, true, false, "any", true)
                              SetrOrderNo(valCode)
                            }}
                            ActiveSw={IsActive}
                            SwonChange={() => {
                              SetActive(!IsActive)
                            }}
                            Activedisabled={blActiveEnable}
                            Gen_PaymentRemark1={strPayRemarks1}
                            Gen_PaymentRemark1_OnChange={e => {
                              let valCode = Text(e.target, 50, true, true, "any", true)
                              SetPayRemarks1(valCode)
                            }}
                            Gen_PaymentRemark1_Enabled={blPayRemarks1Enable}
                            dispCustomer={dispCustomer}
                            dispSupplier={dispSupplier}
                            dispSalesExec={dispSalesExec}
                            dispMode={dispMode}
                            tog_xlarge_supplier={tog_xlarge_supplier}
                            model_xlarge_supplier={model_xlarge_supplier}
                            tog_xlarge_customer={tog_xlarge_customer}
                            model_xlarge_customer={model_xlarge_customer}
                            tog_xlarge_saleExec={tog_xlarge_saleExec}
                            model_xlarge_saleExec={model_xlarge_saleExec}
                            tog_xlarge_location={tog_xlarge_location}
                            model_xlarge_mode={model_xlarge_mode}
                            tog_xlarge_mode={tog_xlarge_mode}
                            model_xlarge_location={model_xlarge_location}
                            strCustomer={strCustomer}
                            strCustomerName={strCustomerName}
                            strSupplier={strSupplier}
                            strSupplierName={strSupplierName}
                            strSalesExec={strSalesExec}
                            strSalesExecName={strSalesExecName}
                            strLocation={strLocation}
                            strLocationName={strLocationName}
                            strMode={strMode}
                            strModeName={strModeName}
                            Gen_LoadInvoices={Gen_LoadInvoices}
                            AutoAllocate={AutoAllocate}
                            TotalPayValue={TotalPayValue}
                            Disabled={disabled}
                            disableTransBTN={disableTransBTN}
                            advancePayment={advancePayment}
                            Gen_Vendor_Enabled={Gen_Vendor_Disabled}
                            Gen_Customer_Enabled={Gen_Customer_Disabled}
                            Gen_Location_Enabled={Gen_Location_Disabled}
                            Gen_Mod_Enabled={Gen_Mode_Disabled}
                            Gen_SaAssis_Enabled={Gen_SalesExec_Disabled}
                            PY_SUP_DISPLAY={PY_SUP_DISPLAY}
                            PY_CUS_DISPLAY={PY_CUS_DISPLAY}
                            PY_SA_DISPLAY={PY_SA_DISPLAY}
                            PY_SUP_SEARCH={PY_SUP_SEARCH}
                            PY_CUS_SEARCH={PY_CUS_SEARCH}
                            PY_SA_SEARCH={PY_SA_SEARCH}
                            ProcessDisable={ProcessDisable}
                            ReasonTypes={ReasonTypes}
                            RemarksOnchange={e => {
                              SetRemarks2(e["value"])
                            }}
                            strRemarks2={strRemarks2}
                            LocationCode={LocationCode}
                          />
                        </Row>
                        <Row>
                          <CreditNoteDetails
                            DataRow={detailTable}
                            setDetailTable={setDetailTable}
                            TotalCalculation={TotalCalculation}
                            Disabled={disabled}
                            GrossAmount={dbGrossAmount}
                            SellingAmount={dbSellingAmount}
                            DiscountPer={dbDiscountPer}
                            DiscountPer_OnChange={e => {
                              let valDiscountPer = Numeric(e.target, 8, txnDecimalAmt, false)
                              if (valDiscountPer == "") {
                                SetdbDiscountPer(0.0)
                              } else {
                                SetdbDiscountPer(valDiscountPer)
                              }
                            }}
                            DiscountPer_OnBlur={e => {
                              let valDiscountPer = Numeric(e.target, 8, txnDecimalAmt, false)
                              if (valDiscountPer == "") {
                                SetdbDiscountPer(0.0)
                              } else {
                                if (valDiscountPer <= 100) {
                                  let NetAmount =
                                    (parseFloat(dbGrossAmount)) -
                                    ((parseFloat(dbGrossAmount) *
                                      parseFloat(e.target.value)) /
                                      100)
                                  SetdbNetAmount(parseFloat(NetAmount, 10).toFixed(txnDecimalAmt))
                                } else {
                                  SetdbDiscountPer(0.0)
                                }
                              }
                            }}
                            NetAmount={dbNetAmount}
                            TotalBookQty={TotalBookQty}
                            TotalCostValue={TotalCostValue}
                            TotalSellingValue={TotalSellingValue}
                            SupplierCode={strCustomer}
                            ShowTaxTable={ShowTaxTable}
                            blDiasableGrid={blDiasableGrid}
                            menuCode={menuCode}
                            DataPayRow={rowsPay}
                            setRowsPay={setRowsPay}
                            TotalPayCalculation={TotalPayCalculation}
                            TotalPayValue={TotalPayValue}
                            Type={type}
                            TotalNetAmount={TotalNetAmount}
                            TotalPaidAmount={TotalPaidAmount}
                            TotalDueAmount={TotalDueAmount}
                            TotalPaymentAmout={TotalPaymentAmout}
                            OverPay={overPay}
                            dispSupplier={dispSupplier}
                            strSupplier={strSupplier}
                            advancePayment={advancePayment}
                            ProcessDisable={ProcessDisable}
                            isDocProcessed={isDocProcessed}
                            addNew={addNew}
                            handlePrintCheque={handlePrintCheque}
                          />
                        </Row>
                      </TabPane>

                      <TabPane tabId="2">
                        <CreditNoteDocumets
                          selectedAttachFiles={selectedAttachFiles}
                          setAttachFileNames={setAttachFileNames}
                          attachFileNames={attachFileNames}
                          setSelectedAttachFiles={setSelectedAttachFiles}
                          clearStatus={handleClearStatus}
                          disable={blDiasableGrid}
                          clearAttachmentEdit={clearAttachmentEdit}
                        />
                      </TabPane>
                      <TabPane tabId="3">
                        <CreditNoteApprovals
                          payTxnSetup={payTxnSetup}
                          locationCode={strLocation}
                          locaionName={strLocationName}
                          mdBy={mdBy}
                          txnDate={strDate}
                          TotalPayValue={TotalPayValue}
                          DocumentNo={strCode}
                          ApprovelDetails={approvalRequests}
                          GetSelectRow1={GetSelectRow1}
                        />
                      </TabPane>
                    </TabContent>
                  </Row>
                  <Row>
                    {crEnable ? (
                      <DPInfoBox
                        createdBy={crBy}
                        createdOn={crDate}
                        modifiedBy={mdBy}
                        modifiedOn={mdDate}
                      />
                    ) : null}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CreditNote



